import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/servicePage.js";

// Sections for this page
import PriceListing from "./Sections/PriceListing";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function WaxPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const items = [
    {name: "Refreshing Facial", price: "$15"},
    {name: "Gold Facial", price: "$30"},
    {name: "Back Facial", price: "$25"},
    {name: "Acne Facial", price: "$50"},
    {name: "Four Layer Facial", price: "$60"},
    {name: "Pearl Facial", price: "$35"},
    {name: "Detox Facial", price: "$35"},
    {name: "Instant Beach Glow", price: "$20"},
    {name: "Diamond Facial", price: "$50"}
  ]
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        brand="Lili's Waxing and Threading Studio"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/facial2.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>Facials</h1>
              <h4>
              Our facials will leave your skin super smooth, clear, clean, and glowing. 
              We use natural steam to remove all blackheads underneath your skin, and finish off with a relaxing face massage.
              </h4>
              <br />
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <PriceListing products={items}/>
        </div>
      </div>
      <Footer />
    </div>
  );
}
